export default __webpack_public_path__ + "static/media/as.0f86acd1.svg";